import { makeStyles } from "@material-ui/styles";

const borderRadius = 4;
const rowHeight = 48;

const matchStyles = makeStyles((theme) => ({
	table: {
		color: theme.palette.gameMode.primary,
		borderRadius,
		border: "1px solid rgba(224, 224, 224, 1)",
		borderCollapse: "separate",
		"& > thead > tr": {
			height: rowHeight,
			backgroundColor: "transparent",
			"& > th": {
				backgroundColor: "transparent"
			}
		},
		"& > tbody > tr": {
			height: rowHeight,
			"& > td": {
				fontWeight: "bold"
			},
			"&:last-child": {
				"& > td": {
					borderBottom: "none",
					"&:first-child": {
						borderRadius: `0 0 0 ${borderRadius}px`
					},
					"&:last-child": {
						borderRadius: `0 0 ${borderRadius}px 0`
					}
				}
			}
		}
	},
	actionMenu: {
		padding: "0 !important",
		background: theme.palette.common.white
	},
	box: {
		width: "100%",
		overflow: "hidden",
		padding: ({ disableActions }) =>
			disableActions ? theme.spacing(1, 1) : theme.spacing(2, 4),
		[theme.breakpoints.only("xs")]: {
			padding: ({ disableActions }) =>
				disableActions ? theme.spacing(1, 0) : theme.spacing(1, 1)
		}
	},
	tableWrapper: {
		overflowX: "auto",
		"& .fixed-first-child": {
			"& tr > th:first-child, & tr > td:first-child": {
				position: "sticky",
				left: 0,
				zIndex: 1
			}
		},
		"& .fixed-last-child": {
			"& tr > th:last-child, & tr > td:last-child": {
				position: "sticky",
				right: 0,
				zIndex: 1,
				padding: 0
			}
		},
		"& tr:nth-of-type(odd) > td, & tr:nth-of-type(odd) > th": {
			background: theme.palette.common.white
		},
		"& tr:nth-of-type(even) > td, & tr:nth-of-type(even) > th": {
			background: "#FAFAFA"
		}
	},
	tiebreak: {
		verticalAlign: "super",
		fontSize: ".83em",
		fontWeight: "normal"
	},
	trophy: {
		color: theme.palette.primary.main,
		padding: "0 10px",
		height: 16
	},
	paperWidthSm: {
		maxWidth: 975,
		width: "100%"
	},
	settingsLabel: {
		fontSize: ".8em"
	}
}));

export default matchStyles;
